import React, { useState } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const ImageWithLightbox = ({
  thumbnailSrc,
  largeSrc,
  width,
  height,
  objectFit,
  objectPosition,
  borderRadius,
  fileName,
  alt = '썸네일',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <React.Fragment>
      <img
        src={thumbnailSrc}
        alt={alt}
        onClick={() => setIsOpen(true)}
        style={{
          maxWidth: '100%',
          width: `${width}px`,
          height: `${height}px`,
          objectFit: objectFit || '',
          objectPosition: objectPosition || 'center',
          borderRadius: borderRadius || '8px',
          cursor: 'pointer',
          boxShadow: `rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px`,
        }}
      />
      <div style={{ display: 'block', padding: 4 }}>{fileName || ''}</div>

      {isOpen && <Lightbox mainSrc={largeSrc} onCloseRequest={() => setIsOpen(false)} imageCaption={alt} />}
    </React.Fragment>
  );
};

export default ImageWithLightbox;
